// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem4,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorTextRequired,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    IconButtonConfiguracao,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import EstudoFormPaginaAdicionalConfiguracao from './EstudoFormPaginaAdicionalConfiguracao'

import {
    incrementaContPaginaAdicional,
    processaRegistrosDefaultIniciaisPaginaAdicional,
} from './EstudoServicePaginaAdicional'



const EstudoFormPaginaAdicional = ({ values, handleChange, handleSubmit, setFieldValue, vars }) => {

    processaRegistrosDefaultIniciaisPaginaAdicional(values)

    const paginaList = () => {

        const paginaListAux = []

        vars.jsonPagina.configuracaoPagina?.forEach( (linha, ind) => {

            if (!linha.tipoRegimeBens && !linha.ufInventario) {
                
                paginaListAux.push(
                    {
                        id: linha.id,
                        descricao: linha.descricaoPagina,
                    }
                )
            }
        })

        return paginaListAux
    }


    
    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem12>
                    <FieldArray name="paginaAdicional">
                        {(arrayHelpers) => (
                            <CardGridEntradaDados>
                                <CardGridDivHeaderEntradaDados>
                                    <CardGridDivEntradaDados>
                                        {LABEL.paginaAdicional}
                                    </CardGridDivEntradaDados>
                                </CardGridDivHeaderEntradaDados>

                                <CardGridDivBodyEntradaDados>
                                    <DivForm>
                                        {values.paginaAdicional?.map((item, ind) => {
                                            return (
                                                <GridContainer
                                                    key={ind}
                                                >
                                                    <GridItem12>
                                                        <GridContainer>
                                                            <GridItem4>
                                                                <TextValidatorTextRequired
                                                                    name={`paginaAdicional[${ind}].descricaoPagina`}
                                                                    label={LABEL.pagina}
                                                                    value={item.descricaoPagina || ''}
                                                                    onChange={handleChange}
                                                                    tamMax={TAMMAX.descricaoPagina}
                                                                    notToUpperCase={true}
                                                                />
                                                            </GridItem4>

                                                            <GridItem4>
                                                                <TextValidatorTextRequired
                                                                    name={`paginaAdicional[${ind}].tituloPagina`}
                                                                    label={LABEL.tituloPagina}
                                                                    value={item.tituloPagina || ''}
                                                                    onChange={handleChange}
                                                                    tamMax={TAMMAX.tituloPagina}
                                                                    notToUpperCase={true}
                                                                />
                                                            </GridItem4>

                                                            <GridItem1
                                                                className='mt-2'
                                                            >
                                                                <CheckboxPadrao
                                                                    name={`paginaAdicional[${ind}].paginaInteira`}
                                                                    label={LABEL.paginaInteira}
                                                                    checked={item.paginaInteira}
                                                                    onChange={handleChange}
                                                                />
                                                            </GridItem1>

                                                            <GridItem1
                                                                className='mt-2'
                                                            >
                                                                {item.paginaInteira && (
                                                                    <div
                                                                        className='ml-5'
                                                                    >
                                                                        <CheckboxPadrao
                                                                            name={`paginaAdicional[${ind}].capa`}
                                                                            label={LABEL.capa}
                                                                            checked={item.capa}
                                                                            onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </GridItem1>

                                                            <GridItem1>
                                                                <TextValidatorNumberRequired
                                                                    name={`paginaAdicional[${ind}].ordem`}
                                                                    label={LABEL.ordem}
                                                                    value={item.ordem === 0 ? 0 : item.ordem || ''}
                                                                    onChange={handleChange}
                                                                    numMin={NUMMIN.ordem}
                                                                    numMax={NUMMAX.ordem}
                                                                />
                                                            </GridItem1>

                                                            <GridItem1>
                                                                <GridContainer>
                                                                    <GridItem6
                                                                        className='mt-1'
                                                                    >
                                                                        <CustomizedDialogsPopup
                                                                            maxWidth="lg"
                                                                            popupTitle={LABEL.paginaAdicional +
                                                                                (
                                                                                    item.descricaoPagina ? ': ' + 
                                                                                    item.descricaoPagina : ''
                                                                                )
                                                                            }
                                                                            tooltipTitle={LABEL.paginaAdicional}
                                                                            PopupButton={IconButtonConfiguracao}
                                                                            popupButtonDestaque={
                                                                                item.itemPagina && item.itemPagina.length > 0
                                                                            }
                                                                            popupComponent={
                                                                                <EstudoFormPaginaAdicionalConfiguracao
                                                                                    values={values}
                                                                                    ind={ind}
                                                                                    handleChange={handleChange}
                                                                                    setFieldValue={setFieldValue}
                                                                                />
                                                                            }
                                                                        />
                                                                    </GridItem6>

                                                                    <GridItem6
                                                                        className='mt-1'
                                                                    >
                                                                        <IconButtonClearEntradaDados
                                                                            type="submit"
                                                                            onClick={() =>
                                                                                arrayHelpers.remove(ind)
                                                                            }
                                                                        />
                                                                    </GridItem6>
                                                                </GridContainer>
                                                            </GridItem1>
                                                        </GridContainer>
                                                    </GridItem12>
                                                </GridContainer>
                                            )
                                        })}
                                    </DivForm>

                                    <GridContainer>
                                        <GridItem4>
                                            <div
                                                className='ml--1 mt-4'
                                            >
                                                <ButtonIncluirLinha
                                                    label={LABEL.buttonIncluirPagina} 
                                                    onClick={() => 
                                                        {
                                                            incrementaContPaginaAdicional(values)

                                                            arrayHelpers.push({
                                                                id: LABEL.paginaAdicional + values.contPaginaAdicional,
                                                                ordem: values.contPaginaAdicional,
                                                            })
                                                        }
                                                    }
                                                />
                                            </div>
                                        </GridItem4>

                                        <GridItem4>
                                            <TextFieldTextSelect
                                                name='paginaIncluirPaginaAPartirDeUmaExistente'
                                                label={LABEL.buttonIncluirPaginaAPartirDeUmaExistente}
                                                value={values.paginaIncluirPaginaAPartirDeUmaExistente || ''}
                                                onChange={handleChange}
                                                list={paginaList()}
                                            />
                                        </GridItem4>

                                        {values.paginaIncluirPaginaAPartirDeUmaExistente && (
                                            <GridItem4>
                                                <div
                                                    className='ml--1 mt-4'
                                                >
                                                    <ButtonIncluirLinha
                                                        label={LABEL.buttonIncluirPaginaAPartirDeUmaExistente} 
                                                        onClick={() => 
                                                            {
                                                                incrementaContPaginaAdicional(values)

                                                                const linhaConfiguracaoPagina =
                                                                    pesquisaList(vars.jsonPagina.configuracaoPagina,
                                                                        values.paginaIncluirPaginaAPartirDeUmaExistente)

                                                                const itemPagina = []

                                                                linhaConfiguracaoPagina.itemPagina?.forEach( (linha, ind) => {

                                                                    itemPagina.push({
                                                                        id: ind + 1,
                                                                        tipoItemPagina: linha.tipoItemPagina,
                                                                        richText: linha.richText,
                                                                        html: linha.html,
                                                                        graficoTabela: linha.graficoTabela,
                                                                        margemTop: linha.margemTop,
                                                                        margemLeft: linha.margemLeft,
                                                                    })
                                                                })

                                                                arrayHelpers.push({
                                                                    id: LABEL.paginaAdicional + values.contPaginaAdicional,
                                                                    descricaoPagina: linhaConfiguracaoPagina.descricaoPagina + ' (' + LABEL.copia + ')',
                                                                    tituloPagina: linhaConfiguracaoPagina.tituloPagina,
                                                                    paginaInteira: linhaConfiguracaoPagina.paginaInteira,
                                                                    capa: linhaConfiguracaoPagina.capa,
                                                                    ordem: values.contPaginaAdicional,
                                                                    contItemPagina: linhaConfiguracaoPagina.itemPagina.length,
                                                                    itemPagina: itemPagina,
                                                                })
                                                            }
                                                        }
                                                    />
                                                </div>
                                            </GridItem4>
                                        )}
                                    </GridContainer>
                                </CardGridDivBodyEntradaDados>
                            </CardGridEntradaDados>
                        )}
                    </FieldArray>
                </GridItem12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default EstudoFormPaginaAdicional